// extracted by mini-css-extract-plugin
export var root = "_ze-0";
export var scroll = "_ze-1";
export var thumb = "_ze-3";
export var track = "_ze-2";